import { render, staticRenderFns } from "./PartnersCard.vue?vue&type=template&id=9a6b2b10&scoped=true"
import script from "./PartnersCard.vue?vue&type=script&lang=js"
export * from "./PartnersCard.vue?vue&type=script&lang=js"
import style0 from "./PartnersCard.vue?vue&type=style&index=0&id=9a6b2b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6b2b10",
  null
  
)

export default component.exports